export function sanitizeArticleCode(param?: any): string {
  // Handle multiple &a= query parameters (take the first one)
  const articleCode = Array.isArray(param) ? param[0] : param;

  return articleCode;
}
